import { flowRight } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import getOuterUrl from '../../../app/services/get-outer-url';
import { getPostCover } from '../../../app/services/get-post-cover';
import { getImageContainerSize } from '../../../app/services/get-post-cover-height';
import withPermissions from '../../../app/hoc/with-permissions';
import withDeviceType from '../../../app/hoc/with-device-type';
import VideoEmbed from '../../../app/components/video-embed';
import PostListItemImage from '../../../app/components/post-list-item-image';
import PostListItemVideoThumbnail from '../../../app/components/post-list-item-video-thumbnail';
import withNavigation from '../../../app/hoc/with-navigation';
import withSectionUrl from '../../../app/hoc/with-section-url';

// eslint-disable-next-line react/prop-types
const renderVideoEmbed = ({ oembed, postLink, canPlayVideo, videoClassName, navigation: { Link } }) => {
  if (!oembed) {
    return null;
  }

  return canPlayVideo ? (
    <VideoEmbed oembed={oembed} className={videoClassName} />
  ) : (
    <div className={videoClassName}>
      <Link to={postLink}>
        <PostListItemVideoThumbnail oembed={oembed} />
      </Link>
    </div>
  );
};

// eslint-disable-next-line react/prop-types
const renderImage = ({ image, url, isPublic, postLink, type, imageClassName, isMobile, navigation: { Link } }) => {
  if (!image) {
    return null;
  }

  let containerStyle = {};
  let imgContainerSize = {};
  if (!isMobile) {
    imgContainerSize = getImageContainerSize(image, type);
    containerStyle = { height: `${imgContainerSize.height}px`, minHeight: `${imgContainerSize.height}px` }; // minHeight for Firefox
  }

  return (
    <div style={containerStyle} className={imageClassName}>
      <Link to={postLink}>
        <PostListItemImage
          image={image}
          url={url}
          isPublic={isPublic}
          height={imgContainerSize.height}
          width={imgContainerSize.width}
        />
      </Link>
    </div>
  );
};

export const PostListItemCover = ({
  post,
  postLink,
  type,
  canPlayVideo,
  videoClassName,
  imageClassName,
  can,
  isMobile,
  navigation,
  sectionUrl,
}) => {
  const { shouldRender, imageMetadata, videoMetadata } = getPostCover(post);
  if (!shouldRender) {
    return null;
  }
  return (
    renderImage({
      image: imageMetadata,
      url: getOuterUrl(postLink, sectionUrl),
      isPublic: can('share', 'post', post),
      postLink,
      type,
      imageClassName,
      isMobile,
      navigation,
    }) ||
    renderVideoEmbed({
      oembed: videoMetadata,
      postLink,
      canPlayVideo,
      videoClassName,
      navigation,
    })
  );
};

PostListItemCover.propTypes = {
  post: PropTypes.object.isRequired,
  postLink: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  canPlayVideo: PropTypes.bool,
  videoClassName: PropTypes.string,
  imageClassName: PropTypes.string,
  can: PropTypes.func.isRequired,
  isMobile: PropTypes.bool.isRequired,
  navigation: PropTypes.object,
  sectionUrl: PropTypes.string,
};

export default flowRight(withNavigation, withPermissions, withDeviceType, withSectionUrl)(PostListItemCover);
